module.exports = __webpack_public_path__ + "static/img/header-bike.0e2afd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header-bike.png
// module id = NmHv
// module chunks = 3